import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import Pagination from 'react-js-pagination';
import moment from 'moment';

import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  FormGroup,
  Button,
} from 'reactstrap';

import Header from 'components/Headers/Header.js';
import TaxServiceService from './TaxServiceService';

export default class ListTaxServices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      services: [],
      activePage: 1,
      itemsCountPerPage: 100,
      totalItemsCount: 0,
      pageRangeDisplayed: 5,
      search: '',
      loading: false,
    };
    this.deleteService = this.deleteService.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    this.fetchServices(1);
  }

  fetchServices(page) {
    this.setState({ loading: true });
    TaxServiceService.listServices(page, 100, this.state.search)
      .then((response) => {
        this.setState({
          services: response.data.data,
          itemsCountPerPage: response.data.perPage,
          totalItemsCount: response.data.totalData,
          activePage: response.data.currentPage,
          loading: false,
        });
      })
      .catch(() => this.setState({ loading: false }));
  }

  handlePageChange(pageNumber) {
    this.setState({ activePage: pageNumber }, () => this.fetchServices(pageNumber));
  }

  handleSearchChange(e) {
    this.setState({ search: e.target.value }, () => this.fetchServices(1));
  }

  deleteService(slug) {
    if (!window.confirm('Are you sure you want to delete this service?')) return;
    TaxServiceService.deleteService(slug)
      .then(() => {
        NotificationManager.success('Service deleted successfully!', 'Success!', 2000);
        this.fetchServices(this.state.activePage);
      })
      .catch(() => NotificationManager.error('Failed to delete service.', 'Error', 2000));
  }

  render() {
    const { services, loading } = this.state;

    return (
      <>
        <Header />
        <Container className="mt--7" fluid>
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Link to="/admin/tax-service/create">
                    <Button color="info">Add New Service +</Button>
                  </Link>
                </CardHeader>
                <CardHeader className="border-0">
                  <h3 className="mb-0">
                    Tax Services
                    <FormGroup style={{ float: 'right' }}>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search here"
                        onChange={(e) => this.handleSearchChange(e)}
                      />
                    </FormGroup>
                  </h3>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Category</th>
                      <th scope="col">Description</th>
                      <th scope="col">Slug</th>
                      <th scope="col">Status</th>
                      <th scope="col">Created At</th>
                      <th scope="col" />
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="7" className="text-center">Loading...</td>
                      </tr>
                    ) : services.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="text-center">No services found.</td>
                      </tr>
                    ) : (
                      services.map((svc) => (
                        <tr key={svc._id}>
                          <td>{svc.name}</td>
                          <td>{svc.category_id?.category || '-'}</td>
                          <td>
                            {svc.description && svc.description.length > 60
                              ? `${svc.description.substring(0, 60)}...`
                              : svc.description}
                          </td>
                          <td>{svc.slug}</td>
                          <td>
                            <Badge color={svc.status ? 'success' : 'danger'}>
                              {svc.status ? 'Active' : 'Inactive'}
                            </Badge>
                          </td>
                          <td>{moment(svc.createdAt).format('MMM DD, YYYY')}</td>
                          <td className="text-right">
                            <UncontrolledDropdown>
                              <DropdownToggle
                                className="btn-icon-only text-light"
                                href="#pablo"
                                role="button"
                                size="sm"
                                color=""
                                onClick={(e) => e.preventDefault()}
                              >
                                <i className="fas fa-ellipsis-v" />
                              </DropdownToggle>
                              <DropdownMenu className="dropdown-menu-arrow" right>
                                <Link to={`/admin/tax-service/edit/${svc.slug}`}>
                                  <DropdownItem>Edit</DropdownItem>
                                </Link>
                                <DropdownItem
                                  href="#!"
                                  onClick={() => this.deleteService(svc.slug)}
                                >
                                  Delete
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
                <CardFooter className="py-4">
                  <nav aria-label="...">
                    <Pagination
                      activePage={this.state.activePage}
                      itemsCountPerPage={this.state.itemsCountPerPage}
                      totalItemsCount={this.state.totalItemsCount}
                      pageRangeDisplayed={this.state.pageRangeDisplayed}
                      onChange={this.handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </nav>
                </CardFooter>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}
